var generateStyle = function generateStyle(componentTheme) {
  var maxWidth = {
    maxWidth: '100%'
  };
  return {
    content: {
      fontFamily: componentTheme.contentFontFamily,
      color: componentTheme.contentColor,
      '& iframe': {
        border: 0
      },
      '& p': {
        margin: 0
      },
      '& a': {
        color: componentTheme.linkColor
      },
      // Responsive images (to match canvas behavior)
      // see canvas-lms/app/stylesheets/components/_ic-reset.scss
      '& img': {
        maxWidth: '100%',
        height: 'auto',
        verticalAlign: 'middle',
        border: 0
      }
    },
    container: {
      overflow: 'auto',
      width: '100%',
      '& img': maxWidth,
      '& [data-media-type=video]': maxWidth,
      '& [data-media-type=audio]': maxWidth
    },
    rceWithContent: {
      minHeight: 'initial',
      boxSizing: 'initial'
    },
    rceNoContent: {
      minHeight: componentTheme.rceMinHeight,
      boxSizing: 'border-box'
    },
    screenReaderOnly: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px',
      transform: 'translatez(0)'
    }
  };
};
export default generateStyle;